module.exports = __webpack_public_path__ + "static/media/step2.4fcc9fe2.jpg";